var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widgetWinn" },
    [
      _c(
        "swiper",
        {
          ref: "winnersSlider",
          staticClass: "widgetWinn__list",
          attrs: { options: _vm.sliderOptions }
        },
        _vm._l(_vm.winnerList, function(item, index) {
          return _c("swiper-slide", { key: index }, [
            _c(
              "div",
              {
                staticClass: "widgetWinn__list-item",
                class: { load: _vm.loaded }
              },
              [
                _c("div", {
                  staticClass: "icon",
                  domProps: { innerHTML: _vm._s(item.currencyHtmlCode) }
                }),
                _c("div", { staticClass: "inf" }, [
                  _c("h4", [
                    _vm._v(
                      _vm._s(item.name) +
                        " " +
                        _vm._s(_vm.$t("front.game.info.winners.won")) +
                        " "
                    ),
                    _c("span", {
                      domProps: { innerHTML: _vm._s(item.currencyHtmlCode) }
                    }),
                    _vm._v(" " + _vm._s(item.amount))
                  ]),
                  _c(
                    "p",
                    [
                      _vm._v(
                        _vm._s(_vm.$t("front.game.info.winners.on_game")) +
                          "\n                        "
                      ),
                      _c(
                        "router-link",
                        {
                          attrs: { to: _vm.gameLink(item), event: "" },
                          nativeOn: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.playForReal(item)
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(item.game && item.game.title) +
                              "\n                        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]
            )
          ])
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }